import React from 'react';

import {
	Box,
	ComposedElement,
	SegmentedProgressBar,
	Spacer,
	Typography,
	Card,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { ComponentInfo } from '@components';
import { rem } from '@helpers';

import { useIntroHelper } from './intro.helper';

export const IntroPlaceholder: React.FC = () => {
	const {
		cerise,
		segmentedProgressBarRef,
		carouselLength,
		activeIndex,
		activeCarousel,
		onChangeSegmentedProgressBar,
		timeAnimation,
		resetCarousel,
		paddingRightIcon,
	} = useIntroHelper();

	return (
		<ComponentInfo
			name="IntroPlaceholder"
			type="placeholder"
			as={Box}
			styles={{
				backgroundImage: `url(${activeCarousel?.imageUrl})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				transitionProperty: 'background',
				transitionDuration: '1s',
				transitionTimingFunction: 'ease-in-out',
				height: '100%',
				width: '100%',
			}}
		>
			<Box
				styles={{
					height: '100%',
					width: '100%',
					justifyContent: 'flex-end',
					alignItems: 'flex-end',
				}}
			>
				<Card.Widget appearance="tertiary" width={rem(400)} margin={rem(0, 40, 40, 0)} spacing="medium">
					<div>
						<Typography appearance="subtitle-200-02">{activeCarousel?.title}</Typography>
					</div>
					<Spacer vertical={16} />
					<div>
						<Typography appearance="body-100-02">{activeCarousel?.subtitle}</Typography>
					</div>
					{activeCarousel?.icon !== undefined && (
						<>
							<Spacer vertical={16} />
							<Box styles={{ justifyContent: 'center', alignItems: 'center', width: rem(400) }}>
								{activeCarousel?.icon?.map((icon: string, index: number) => {
									return (
										<div
											key={index}
											style={{
												paddingRight: paddingRightIcon(index),
											}}
										>
											<ComposedElement icon={{ source: icon }} />
										</div>
									);
								})}
							</Box>
						</>
					)}
					<Spacer vertical={16} />
					{carouselLength && (
						<SegmentedProgressBar
							ref={segmentedProgressBarRef}
							numberOfSteps={carouselLength}
							activeStep={activeIndex}
							onChange={onChangeSegmentedProgressBar}
							animationProgressDuration={timeAnimation()}
							onSegmentedProgressFinish={resetCarousel}
							playState={'running'}
							contentProps={{ backgroundColor: cerise, borderRadius: rem(8) }}
							mode={'play'}
						/>
					)}
				</Card.Widget>
			</Box>
		</ComponentInfo>
	);
};
